import { gql } from '@apollo/client';

export const PROGRAM_FIELDS = gql`
    fragment ProgramFields on programs {
        program_id
        client_id
        code
        display_name
        enabled
    }
`;
